import styled from 'styled-components';

const DateFilterWrapper = styled.div`
  padding: 10px;
  .f11 {
    flex: 1 1;
  }
`;

const DateItemWrapper = styled.div`
  background: rgba(234, 234, 234, 0.3);
  border-radius: 5px;
  cursor: pointer;
  margin-right: 10px;
  margin-bottom: 10px;
  padding: 10px 10px 10px 15px;
  &:last-child {
    margin-bottom: 0px;
  }
  &.isActive {
    border: 1px solid black;
  }
`;

const FilterOptionHolder = styled.div`
  min-width: 120px;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (props.disabled ? '0.8' : '1')};
  background: ${(props) => (props.disabled ? '#f2f2f2' : 'inherit')};
  border-bottom: ${(props) => (props.isNewLayout ? 'none' : '1px solid #eee')};
  height: 38px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .filter-text {
    margin: 0 2px;
    color: hsl(0, 0%, 50%);
    user-select: none;
    &.isPresent {
      color: inherit;
    }
  }
  .drpdwn {
    svg {
      color: hsl(0, 0%, 80%);
      &:hover {
        color: hsl(0, 0%, 60%);
      }
    }
  }
`;

const RangeSelector = styled.select`
  border-radius: 4px;
  appearance: none;
  border: none;
  font-weight: 600;
  padding: 5px 10px;
  outline: none;
  text-align-last: center;
`;

export {
  DateFilterWrapper,
  DateItemWrapper,
  FilterOptionHolder,
  RangeSelector
};
